import { Bound } from "lib/@components/binding/Bound"
import { register } from "lib/routes/register"
import AuthGuard from "minimals-template/components/guards/AuthGuard"
import { AuthoringHeaderBarRight, AuthoringAppLayout } from "./@layouts/authoring-app-layout"
import { Box } from "@mui/material"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import Iconify from "minimals-template/components/Iconify"
import { SettingsButtonPortal } from "minimals-template/components/settings/drawer"
import { AuthoringHomePage } from "./home/authoring-home-page"
import "./home/authoring-home.runtime"
import AccountPopover from "routes/@layouts/app/header/AccountPopover"
import { NotOnMobile } from "lib/@components/mobile"
import Logo from "minimals-template/components/Logo"
import { Feature, isEnabled } from "lib/@components/feature"
import { Redirect } from "lib/@components/redirect"
import { registerFeatureWithDescription } from "lib/features"
import { AuthenticatedApplicationSwitcher, DebugButton } from "plugins/navigation/home/home.runtime"
import { FEATURE_FLAG_SIDE_NAV_REDESIGN } from "routes/@layouts/app/navbar/feature-flag-side-nav-redesign.runtime"

export const FEATURE_FLAG_AUTHORING = registerFeatureWithDescription({
    numericalId: 401,
    id: "authoring",
    name: "Technical Authoring Application",
    readyForProduction: true,
    descriptionLines: ["Grants Access to the Technical Authoring Feature"],
})

export const authoringRoute = (window.AuthoringRoute = register("/authoring", <Authoring />))
authoringRoute.register("", <AuthoringHomePage $lazy />)

registerConditionalPageNavigation(() => true, "/authoring", "Home", <Iconify icon="material-symbols:home-rounded" />)

AuthoringHeaderBarRight.plug(<DebugButton priority={-1000} />)
AuthoringHeaderBarRight.plug(<AuthenticatedApplicationSwitcher if={notRedesignedNav} />)
AuthoringHeaderBarRight.plug(<SettingsButtonPortal priority={50} $lazy />)

AuthoringHeaderBarRight.plug(
    <Box pl={1} priority={10000}>
        <AccountPopover menuOptions={[{ label: "Home", linkTo: "/authoring" }]} $lazy />
    </Box>
)
AuthoringHeaderBarRight.plug(
    <NotOnMobile priority={30000}>
        <Logo $lazy />
    </NotOnMobile>
)

function Authoring() {
    return (
        <Bound dontNeedLicense>
            <AuthGuard>
                <Feature feature={FEATURE_FLAG_AUTHORING} fallback={<Redirect to="/app" />}>
                    <AuthoringAppLayout />
                </Feature>
            </AuthGuard>
        </Bound>
    )
}

function notRedesignedNav() {
    return !isEnabled(FEATURE_FLAG_SIDE_NAV_REDESIGN)
}
